module.exports = "/roster/components/rosterTableComponent-03eb05.html";